<script setup lang="ts">
import { computed, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppShell from '@/components/AppShell.vue'
import { redirectFor } from '@/router'
import { useAdminStore } from '@/stores/admin'
import { useAuthStore } from '@/stores/auth'
import { useCatalogStore } from '@/stores/catalog'

const auth = useAuthStore()
const catalog = useCatalogStore()
const admin = useAdminStore()
const route = useRoute()
const router = useRouter()

const bare = computed(() => route.meta.bare === true)

// Réaction aux changements de rôle (RG-03) : abonnement au catalogue, pastille
// d'administration, et sortie d'une page devenue interdite.
watch(
  () => [auth.ready, auth.role, auth.user?.uid] as const,
  ([ready]) => {
    if (!ready) return
    if (auth.isMember) catalog.start()
    else catalog.stop()
    if (auth.isSuperadmin) void admin.load()
    else admin.clear()
    const target = redirectFor(route)
    if (target) void router.replace(target)
  },
  { immediate: true },
)
</script>

<template>
  <div v-if="!auth.ready" class="boot" aria-busy="true">
    <span class="serif">Ex Libris</span>
  </div>
  <RouterView v-else-if="bare" />
  <AppShell v-else>
    <RouterView />
  </AppShell>
</template>

<style scoped>
.boot {
  min-height: 100dvh;
  display: grid;
  place-items: center;
  font-size: 32px;
  opacity: 0.5;
}
</style>
